import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';

import './mobile-new-flash-sale-style.scss';
import TimesaleIcon from '@src/imagesNew/icons/timesale.png';

import { Loading } from '@src/components/atoms';
import Timer from '@src/componentsNew/Timer';
import Typography from '@src/componentsNew/Typography/Typography';
import MobileVerticalProductThumbnail from '@src/componentsNew/ProductThumbnail/VerticalProductThumbnail/MobileVerticalProductThumbnail';

import { MOBILE_HUGE_SALE } from './queries';
import {
  mobileTodayHugeSale,
  mobileTodayHugeSale_todayHugeSale_products_edges,
} from './__generated__/mobileTodayHugeSale';
import { TimesaleLogoIcon } from "@src/componentsNew/ProductList/NewFlashSale/TimesaleLogoIcon";

const MobileNewFlashSale = () => {
  const [seconds, setSeconds] = useState(0);
  const [shuffledProducts, setShuffledProducts] = useState<mobileTodayHugeSale_todayHugeSale_products_edges[]>([]);

  const { data, loading } = useQuery<mobileTodayHugeSale>(MOBILE_HUGE_SALE, {
    variables: {
      first: 20,
    },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data.todayHugeSale !== null) {
        const [year, month, day] = data.todayHugeSale.eventDate.split('-');
        const endDate = new Date(+year, +month - 1, +day, 23, 59, 59);
        const now = new Date();
        const diffSeconds = Math.floor((endDate.getTime() - now.getTime()) / 1000);
        setSeconds(diffSeconds);

        if (data.todayHugeSale.products?.edges) {
          const shuffled = [...data.todayHugeSale.products.edges].sort(() => Math.random() - 0.5);

          setShuffledProducts(shuffled);
        }
      }
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => (prevSeconds === 0 ? 0 : prevSeconds - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return shuffledProducts?.length ? (
    <div className="mobile-new-flash-sale-wrapper">
      <div className="flash-sale-title">
        <TimesaleLogoIcon src={TimesaleIcon}/>
        <Typography variant="subtitle1" component="h4" style={{ color: '#090A0FDE' }}>
          TIME SALE
        </Typography>
        <Timer seconds={seconds} timerTypoVariant="body2" />
      </div>

      <div className="flash-sale-products-wrapper">
        {shuffledProducts.map((item) => (
          <MobileVerticalProductThumbnail key={item.node.id} product={item.node} isVerticalOne={false} />
        ))}
      </div>
    </div>
  ) : null;
};

export default MobileNewFlashSale;
